import React from "react";

export const initials = (name) => (name || "?").split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export function UserAvatar({ name, url, className = "h-9 w-9 text-sm", testId }) {
  return (
    <div data-testid={testId} className={`${className} rounded-full bg-white/15 border border-white/30 overflow-hidden grid place-items-center shrink-0 font-heading font-bold`}>
      {url ? <img src={url} alt={name || ""} className="h-full w-full object-cover" /> : <span>{initials(name)}</span>}
    </div>
  );
}
